import { createLink } from '@tanstack/react-router';
import Fab, { type FabProps } from '@mui/material/Fab';
import { forwardRef } from 'react'

// Router-compatible Floating Action Button
export const RouterFab = createLink(
  forwardRef<HTMLButtonElement, FabProps>((props, ref) => {
    return <Fab ref={ref} {...props} />
  }),
)